/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import {
  Content,
  Footer,
  FooterWrapper,
  Header,
  Page,
  Panel,
  Progress,
  SidebarWrapper,
  useLayout,
} from '@eleveo/components-react';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useLocation, useOutlet, useSearchParams } from 'react-router-dom';
// @ts-expect-error: TODO: Resolve peer deps
import { CSSTransition } from 'react-transition-group';

import { MyIntegrationsBottomBar, MyIntegrationsContent, MyIntegrationsTopBar } from './MyIntegrations';
import { DEFAULT_PAGE_SIZE, INITIAL_PAGE, useConfigurationsQuery } from '../../api/integrationsQuery';
import { ETLConfigurationPage } from '../../api/types';
import { SUPPORTED_INTEGRATIONS } from '../../components/configuration/types';
import { TEST_IDS } from '../../constants/dataTestIds';
import { getPaginationParamsFromSearchParams } from '../../utils/paginationUtils';

const initialConfigurationPage = {
  content: [],
  page: INITIAL_PAGE - 1,
  pageSize: DEFAULT_PAGE_SIZE,
  total: 0,
  totalPages: 1,
};

export const MyIntegrationsContainer: React.FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const currentOutlet = useOutlet();

  const { sidebar } = useLayout({
    floating: true,
  });

  const [lastSuccessfulPage, setLastSuccessfulPage] = useState<ETLConfigurationPage | undefined>(undefined);

  const [searchParams] = useSearchParams();
  const integrationsQueryData = useConfigurationsQuery(
    ...getPaginationParamsFromSearchParams(searchParams),
    SUPPORTED_INTEGRATIONS
  );

  useEffect(() => {
    if (integrationsQueryData.status !== 'success') {
      return;
    }

    setLastSuccessfulPage(integrationsQueryData.data);
  }, [integrationsQueryData]);

  // isIdle detects query that was not run, that means was initialized with enabled false user does not have permissions
  const { isLoading } = integrationsQueryData;
  const dataToRender =
    integrationsQueryData.status === 'success' ? integrationsQueryData.data : initialConfigurationPage;

  const handleEnter = () => {
    // @ts-expect-error: Using internal
    sidebar._add(pathname);
  };

  const handleExit = () => {
    // @ts-expect-error: Using internal
    sidebar._remove(pathname);
  };

  return (
    <Page>
      <Helmet>
        <title>{t('applications.ETLManagement')}</title>
      </Helmet>

      {isLoading && <Progress withOverlay />}

      <Header title="My configurations" />

      <Panel>
        <MyIntegrationsTopBar />
      </Panel>

      <Content testId={TEST_IDS.myIntegrationsScene}>
        <MyIntegrationsContent integrations={dataToRender} isLoading={isLoading} />
      </Content>

      <SidebarWrapper>
        {currentOutlet && (
          <CSSTransition
            appear
            key={pathname}
            onEnter={handleEnter}
            onExit={handleExit}
            classNames="layout"
            timeout={450}
          >
            <>{currentOutlet}</>
          </CSSTransition>
        )}
      </SidebarWrapper>

      <FooterWrapper>
        {lastSuccessfulPage && lastSuccessfulPage.total > DEFAULT_PAGE_SIZE && (
          <Footer>
            <MyIntegrationsBottomBar integrations={lastSuccessfulPage} />
          </Footer>
        )}
      </FooterWrapper>
    </Page>
  );
};
